import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import styledTheme from 'src/styles/styled-theme';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import App from './App';
import { ModalContextProvider } from './context/ModalContext';
import { SnackBarContextProvider } from './context/SnackBarContext';
import { OrderProductLogContextProvider } from './context/OrderProductLogContext';
import { OrderItemWithdrawContextProvider } from './context/OrderProductWithdrawContext';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { store } from './store';
import { createRoot } from 'react-dom/client';
import { StyleSheetManager } from 'styled-components';
import { OverlayProvider } from 'overlay-kit';

// import 'react-grid-layout/css/styles.css';
// import 'react-resizable/css/styles.css';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    // <React.StrictMode>
    <StyleSheetManager shouldForwardProp={() => true}>
        <StyledThemeProvider theme={styledTheme}>
            <ReduxProvider store={store}>
                <BrowserRouter>
                    <HelmetProvider>
                        <ModalContextProvider>
                            <SnackBarContextProvider>
                                <OrderProductLogContextProvider>
                                    <OrderItemWithdrawContextProvider>
                                        <OverlayProvider>
                                            <App />
                                        </OverlayProvider>
                                    </OrderItemWithdrawContextProvider>
                                </OrderProductLogContextProvider>
                            </SnackBarContextProvider>
                        </ModalContextProvider>
                    </HelmetProvider>
                </BrowserRouter>
            </ReduxProvider>
        </StyledThemeProvider>
    </StyleSheetManager>,
    // </React.StrictMode>,
);

// ReactDOM.render(document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
